<script lang="ts">
    import Dialog, {Actions, Content} from '@smui/dialog';
    import {createEventDispatcher, onMount} from "svelte";
    import type {AccessoryStockItem} from "../../../interfaces";
    import {getCookie, getFormatter} from "../../../utils";
    import NauiButton from "../../../naui/atoms/NauiButton.svelte";
    import InputNumber from "../../atoms/InputNumber.svelte";
    import NauiCheckbox from "../../../naui/atoms/NauiCheckbox.svelte";
    import {Cart} from "../../../models/cart";
    import Snackbar, {Label} from "@smui/snackbar";
    import IconButton from "@smui/icon-button";

    export let data: AccessoryStockItem;
    export let cart: Cart;
    let formatter = getFormatter();
    let dispatch = createEventDispatcher();
    let snackbarCmpt;
    let messageSnack;

    let openDialog: boolean = false;

    onMount(() => {
        if (data) {
            placa = data.placa;
        }
    });

    function remove() {
        openDialog = false;
        dispatch('remove');
    }

    function cancelRemove() {
        openDialog = false;
    }

    function update(event) {
        data.item.delivery = !data.installation;
        dispatch('updateInstallation')
    }

    let placa: string;

    async function queryPlaca() {
        if (placa.length >= 6) {
            const res = await fetch('/backend/servicio/agregar-vehiculo/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': getCookie('csrftoken')
                },
                body: JSON.stringify({
                    placa: placa.toUpperCase()
                })
            });
            if (res.ok) {
                const {vin} = await res.json();
                data.vin = vin;
                data.placa = placa;
                await cart.update();
                messageSnack = 'Se actualizo la placa con exito.';
                snackbarCmpt?.open();
            } else {
                messageSnack = 'Error consultando la placa.';
                snackbarCmpt?.open();
            }
        } else {
            messageSnack = 'Placa no valida';
            snackbarCmpt?.open();
        }
    }
</script>
<div>
    <div class="grid-auto-1 gap-1 mb-ii">
        <div style="width: 111px">
            {#if data.item.route}
                <a href={data.item.route} target="_blank">
                    {#if data.item.image}
                        <img class="w-100" src="{data.item.image}" alt="Imagen de accesorio">
                    {:else}
                        <img class="w-100" src="/static/storefront/pix/no_foto.jpg" alt="No photo">
                    {/if}
                </a>
            {:else}
                {#if data.item.image}
                    <img class="w-100" src="{data.item.image}"  alt="Imagen de accesorio">
                {:else}
                    <img class="w-100" src="/static/storefront/pix/no_foto.jpg" alt="No photo">
                {/if}
            {/if}
        </div>
        <div>
            <div class="box-b">
                <div>
                    {#if data.brand}
                        <div style="font-size: 12px">{data.brand}</div>
                    {/if}
                </div>
                <div on:click={()=>openDialog=true}>
                    <img height="15" src="/static/storefront/pix/icons/eliminar.svg" alt="Eliminar">
                </div>
            </div>
            <strong class="block" style="font-size: 14px">{data.item.name}</strong>
            <div class="box-b">
                <div>
                    {#if data.flag}
                        <div class="discount">{data.flag}</div>
                        {#if data.prevPrice}
                            <small>Antes {formatter(data.prevPrice)}</small>
                        {/if}
                    {/if}
                    <div class="price">{formatter(data.price)}</div>
                </div>
                <div>
                    <InputNumber bind:value={data.quantity}
                                 on:updateQuantity/>
                </div>
            </div>
            <div class="my-1">
                <NauiCheckbox label="¿Incluir servicio de instalación?"
                              bind:value={data.installation}
                              on:change={update}/>
            </div>
            <!--Deshabilita captura de placa-->
            {#if false}
                {#if data.vin}
                    <div class="box-r sx-ii">
                        {#if data.placa}
                            <input class="naui-input"
                                   placeholder="Placa"
                                   disabled
                                   bind:value={placa}>
                        {/if}
                        <NauiButton caption="CAMBIAR PLACA"
                                    color="accent"
                                    mode="solid"
                                    on:click={()=>data.vin=null}/>
                    </div>
                {:else}
                    <div class="box-r sx-ii">
                        <input class="naui-input"
                               placeholder="Placa"
                               bind:value={placa}>
                        <NauiButton caption="CONSULTAR"
                                    color="accent"
                                    mode="solid"
                                    on:click={()=>queryPlaca()}/>
                    </div>
                {/if}
            {/if}
        </div>
    </div>
</div>
<Dialog bind:open={openDialog}
        scrimClickAction=""
        escapeKeyAction=""
        aria-describedby="mandatory-content">
    <Content id="mandatory-content">
        ¿Desea eliminar el repuesto <b>{data.item.name}</b> del carrito?
    </Content>
    <Actions>
        <div class="box sx-ii">
            <NauiButton caption="CANCELAR"
                        mode="solid"
                        on:click={()=>cancelRemove()}/>
            <NauiButton caption="ACEPTAR"
                        color="accent"
                        mode="solid"
                        on:click={()=>remove()}/>
        </div>
    </Actions>
</Dialog>

<Snackbar bind:this={snackbarCmpt}>
    <Label>{messageSnack}</Label>
    <Actions>
        <IconButton class="material-icons" title="Dismiss" on:click={()=>snackbarCmpt.close()}>close</IconButton>
    </Actions>
</Snackbar>

<style>
    .discount {
        background: black;
        color: white;
        font-size: 12px;
        font-weight: bold;
        width: max-content;
        padding: 5px;
    }
</style>